import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';

const TopProductsPanel = ({ products, translate }) => {
  const rows = Array.isArray(products) ? products : [];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {translate('home.dashboard.top_products')}
      </Typography>
      {rows.length === 0 ? (
        <Box sx={{ py: 3, color: 'text.secondary', textAlign: 'center' }}>{translate('home.dashboard.no_products')}</Box>
      ) : (
        <TableContainer sx={{ maxHeight: 320 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ bgcolor: 'background.paper' }}>{translate('home.dashboard.col_product')}</TableCell>
                <TableCell sx={{ bgcolor: 'background.paper' }}>{translate('products.code')}</TableCell>
                <TableCell sx={{ bgcolor: 'background.paper' }} align="right">
                  {translate('home.dashboard.col_sku_count')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((p) => (
                <TableRow key={p.id} hover>
                  <TableCell>{p.name}</TableCell>
                  <TableCell>{p.code}</TableCell>
                  <TableCell align="right">{p.sku_count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default TopProductsPanel;
